import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"icon-plus\"><path d=\"M8.004 16.144c.403 0 .745-.32.745-.706V8.876h6.514A.746.746 0 0 0 16 8.147a.741.741 0 0 0-.737-.728H8.749V.849c0-.386-.342-.705-.745-.705-.41 0-.745.32-.745.706v6.569H.745c-.395 0-.745.327-.745.728 0 .394.35.729.745.729h6.514v6.562c0 .386.334.706.745.706Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol